import { mix } from "../utils/math.ts";
import type { Landmark } from "../utils/types.ts";

export function smoothLandmarks(
  previous: Landmark[] | null,
  next: Landmark[],
  amount: number,
): Landmark[] {
  if (!previous || previous.length !== next.length) {
    return next.map((point) => ({ ...point }));
  }
  const t = mix(0.15, 0.65, 1 - amount);
  return next.map((point, i) => {
    const prev = previous[i]!;
    return {
      x: mix(prev.x, point.x, t),
      y: mix(prev.y, point.y, t),
      z: mix(prev.z, point.z, t),
    };
  });
}
